/**
 * Copied from vcvc-prototype-2
 *
 * TODO note that this util could end up in a Fastack package -- we should do a
 * small refactor to import runFetch from that package instead in that case to
 * keep things clean.
 *
 * Thread: https://aops.slack.com/archives/C05K3QX3UNM/p1695060548635489
 */

import "whatwg-fetch";

export type FetchMethod = "GET" | "POST" | "PUT" | "DELETE";

export type FetchProps = {
	url: string;
	body?: null | object;
	mode?: RequestMode;
	method?: FetchMethod;
	signal?: AbortSignal | null;
	securityToken?: string; // required for authenticated requests
};

export type FetchFunc = (props: FetchProps) => Promise<any>;

export type FetchError = Error & {status: number; code?: string};

function defaultFetchRunner(props: FetchProps): Promise<any> {
	const {
		url,
		body,
		mode = "cors", // default per https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#making_cross-origin_requests
		method = "POST",
		signal = null,
		securityToken,
	} = props;

	return global
		.fetch(url, {
			mode,
			method,
			headers: {
				"Content-Type": "application/json",
				"X-CSST-TOKEN": securityToken || "",
			},
			body: body == null ? null : JSON.stringify(body),
			signal: signal,
		})
		.then((res) => {
			if (res && res.status >= 400 && res.status <= 599) {
				return res.text().then((e) => {
					const err: FetchError = new Error(e) as any;
					err.status = res.status;

					try {
						const jsonE: any = JSON.parse(e);
						err.code = jsonE.code ?? undefined;
						const newErrMessage = {
							message: jsonE.message ?? undefined,
							moreInfo: jsonE.moreInfo ?? undefined,
						};
						err.message = JSON.stringify(newErrMessage);
					} catch (error) {}

					throw err;
				});
			} else if (res && typeof res.json === "function") {
				return res.json();
			}
			const err: FetchError = new Error(res.statusText) as any;
			err.status = res ? res.status : 0;
			throw err;
		});
}

let fetchRunner: FetchFunc = defaultFetchRunner;

export function runFetch(props: FetchProps): Promise<any> {
	return fetchRunner(props);
}

export function setFetchRunner(f: FetchFunc) {
	fetchRunner = f;
}

export function setFetchRunnerToDefault() {
	fetchRunner = defaultFetchRunner;
}
